import { skipToken, useQuery } from '@tanstack/react-query';

import { ContextSources } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_CONTEXT_SOURCES_LIST_KEY = 'PRIVATE_CONTEXT_SOURCES_LIST';

export const getPrivateContextSourcesListKey = (params: UsePrivateContextSourcesListParams) => {
  return [PRIVATE_CONTEXT_SOURCES_LIST_KEY, params];
};

export type UsePrivateContextSourcesListParams = Omit<Parameters<typeof ContextSources.list>[0], 'workspaceId'> & {
  workspaceId: string | undefined;
};

export type UsePrivateContextSourcesListOptions = {
  enabled?: boolean;
};

export const usePrivateContextSourcesList = (
  params: UsePrivateContextSourcesListParams,
  options?: UsePrivateContextSourcesListOptions,
) => {
  const { workspaceId } = params;

  return useQuery({
    enabled: !!workspaceId && options?.enabled,
    queryFn: !workspaceId ? skipToken : () => callAirApi(() => ContextSources.list({ ...params, workspaceId })),
    queryKey: getPrivateContextSourcesListKey(params),
    refetchOnWindowFocus: true,
  });
};
